export default __webpack_public_path__ + "static/media/calendar-approved-date.2b12aeee.svg";